import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import Start from '@/views/Start.vue'
import Room from '@/views/Room.vue'
import End from "@/views/End.vue";
import Error from '@/views/Error.vue'
import Intro from "@/views/Intro.vue";
import Authentification from "@/views/Authentification.vue";
import getGame from "@/composables/getGame";
import {useUserStore} from "@/store/useUserStore";

// game guard
const requireGame = async (to: any, from: any, next: any) => {
  const {error, project} = await getGame(to.params.id)
  const userStore = useUserStore()
  console.log("TO", to)
  console.log("roomDocs.value", Object.assign({}, project))
  console.log("Error: ", error.value)

  if (!error.value) {
    const projectData = JSON.parse(JSON.stringify(project))
    to.meta.projectProgress = projectData.progress
    to.meta.times = projectData.times
    to.meta.projectMaxRooms = projectData.maxRooms
    if (userStore.getUid && userStore.playerId && userStore.playerName) {
      to.params.uid = userStore.getUid
      to.params.playerId = userStore.playerId
      to.params.playerName = userStore.playerName
    }
      next()
  } else {
    console.log("Game existiert nicht!")
    next({name:'Home'})
  }
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Intro
  },
  {
    path: '/:lang/:id/',
    name: 'Intro',
    component: Intro,
  },
  {
    path: '/:lang/:id/start',
    name: 'Start',
    component: Start,
    props: true,
    beforeEnter: requireGame,
  },
  {
    path: '/:lang/:id/:room',
    name: 'Room',
    component: Room,
    props: true,
    beforeEnter: requireGame
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "room" */ '../views/Room.vue')
  },
  {
    path: '/:lang/:id/end',
    name: 'End',
      component: End,
    props: true,
    beforeEnter: requireGame
  },
  {
    path: '/admin',
    name: 'Authentification',
    component: Authentification
  },
  {
    path: '/error',
    name: 'Error',
    component: Error
  }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from) => {
  window.scrollTo(0, 0)
})


export default router
